import React from 'react';
import { Progress, Upload } from 'antd';
import { Icon } from 'components/ui';
import { Controller, useFormContext } from 'react-hook-form';
import { useCreateEmailExclusionContext } from '../context';

const { Dragger } = Upload;

export default function ExclusionFilesUploader() {
  const form = useFormContext();
  const { progress, isUploading } = useCreateEmailExclusionContext();
  return (
    <div className="space-y-2">
      <b>Exclusions files</b>
      <div>
        <Controller
          control={form.control}
          name="exclusionFiles"
          render={({ field: { value, onChange } }) => {
            return (
              <>
                {!isUploading && (
                  <Dragger
                    accept="text/csv"
                    beforeUpload={(_, fileList) => {
                      onChange(fileList);
                      return false;
                    }}
                    // disabled={isLoading}
                    multiple
                    showUploadList={false}
                  >
                    <Icon style={{ fontSize: 30 }} type={'upload'} />
                    <p className="ant-upload-text">
                      Click or drag file to this area to upload exclusion files
                    </p>
                  </Dragger>
                )}
                <div className="w-full space-y-2" style={{ marginTop: 10 }}>
                  {value.map(file => {
                    return (
                      <div
                        className="flex items-center justify-between w-full"
                        key={file.uid}
                        style={{ maxWidth: '100%' }}
                      >
                        <div className="space-x-2 truncate" style={{ flex: 1 }}>
                          <Icon style={{ marginRight: 5 }} type="paper-clip" />
                          {file.name}
                        </div>
                        {isUploading ? (
                          <Progress
                            format={percent =>
                              `${(percent || 0)
                                .toFixed(1)
                                .replace(/\.0$/, '')}%`
                            }
                            percent={progress[`exclusionFiles:${file.name}`]}
                            style={{ maxWidth: 150, marginLeft: 10 }}
                          />
                        ) : (
                          <Icon
                            className="cursor-pointer"
                            style={{ fontSize: 20, marginLeft: 10 }}
                            type="delete"
                            onClick={() => {
                              onChange(value.filter(e => e.name !== file.name));
                            }}
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            );
          }}
        />
      </div>
    </div>
  );
}
